import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedArray } from '../../ParseHelper';
import {
    LevelType,
    IPlayerLevelData,
} from '../../../State/Player/Progress/PlayerLevels';

type PlayerStateKey = 'levels';
type PlayerDataKeys = 'stars' | 'friendHelperAttempts';
export default class Levels implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        const stars = playerStateData.levels[LevelType.Core].map(
            levelData => levelData.stars
        );
        const helperFriendAttempts = playerStateData.levels[
            LevelType.Core
        ].map(levelData => levelData.helperFriendAttempts);
        return (
            playerEndpointData.stars !== JSON.stringify(stars) ||
            playerEndpointData.friendHelperAttempts !==
                JSON.stringify(helperFriendAttempts)
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const stars = restoreStringifiedArray<number>(
            playerEndpointData.stars,
            []
        );
        const friendHelperAttempts = restoreStringifiedArray<number>(
            playerEndpointData.friendHelperAttempts,
            []
        );

        return {
            [LevelType.Core]: stars.map<IPlayerLevelData>(
                (stars, index) => ({
                    levelNumber: index + 1,
                    stars,
                    helperFriendAttempts: friendHelperAttempts[index] || 0,
                })
            ),
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        const stars = playerStateData.levels[LevelType.Core].map(
            levelData => levelData.stars
        );
        const friendHelperAttempts = playerStateData.levels[
            LevelType.Core
        ].map(levelData => levelData.helperFriendAttempts);
        return {
            stars: JSON.stringify(stars),
            friendHelperAttempts: JSON.stringify(friendHelperAttempts),
        };
    }
}
